
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.5 2.293l-2.26 2.26-3.37.964a2.03 2.03 0 00-1.401 1.325L2.43 13.137l.717.717.717.717 6.297-2.04a2.028 2.028 0 001.32-1.394l.964-3.374L14.707 5.5 11.5 2.293zm0 1.414L13.293 5.5 12 6.793 10.207 5 11.5 3.707zM9.355 5.562l2.083 2.082-.921 3.226a1.033 1.033 0 01-.668.71l-5.504 1.783 2.898-2.898a1 1 0 10-.707-.707l-2.898 2.897 1.781-5.5a1.036 1.036 0 01.719-.674l3.218-.919z","fill":"#B9C3D3"}})])
          )
        }
      }
    